var _a, _b;
import UpperSupCheckService from "../api/UpperSupCheckService";
export var EHanleType;
(function (EHanleType) {
    EHanleType[EHanleType["Audit"] = 1] = "Audit";
    EHanleType[EHanleType["Delete"] = 2] = "Delete";
})(EHanleType || (EHanleType = {}));
var service = UpperSupCheckService.getInstance();
var handleDict = (_a = {},
    _a[EHanleType.Audit] = service.audit,
    _a[EHanleType.Delete] = service.deleteOrder,
    _a);
var msgDict = (_b = {},
    _b[EHanleType.Audit] = "审核后将不可修改，是否继续？",
    _b[EHanleType.Delete] = "废弃后将不可撤消，是否继续？",
    _b);
export function handle(type, context, params, hideConfirm) {
    if (hideConfirm === void 0) { hideConfirm = false; }
    var promise;
    var confirmPromise = hideConfirm ? Promise.resolve() : context.$confirm(msgDict[type], '提示');
    switch (type) {
        case EHanleType.Delete:
            promise = confirmPromise.then(function () { return simpleAudit(handleDict[type], context, params); });
            break;
        case EHanleType.Audit:
            promise = confirmPromise.then(function () { return audit(handleDict[type], context, params); });
            break;
        default:
            promise = Promise.resolve("ok");
            break;
    }
    return promise;
}
function audit(serviceHandle, context, params) {
    var nextActionFlag = 1;
    return serviceHandle(params).then(function (res) {
        if (res.data.code == 76) {
            context.$message.error(res.data.msg);
        }
        else {
            context.$message.success(res.data.msg);
        }
        context.getList();
    }, function (err) {
        if (err.resData && err.resData.flag === nextActionFlag) {
            context.$confirm(err.resData.msg, {
                confirmButtonText: "废弃"
            }).then(function (res) {
                handle(EHanleType.Delete, context, err.resData.data, true);
            });
        }
        else if (err.msg || err.message) {
            context.$message.error(err.msg || err.message);
        }
    });
}
function simpleAudit(serviceHandle, context, params) {
    return serviceHandle(params).then(function (res) {
        if (res.data.code == 76) {
            context.$message.error(res.data.msg);
        }
        else {
            context.$message.success(res.data.msg);
        }
        context.getList();
    }, function (err) {
        if (err.msg || err.message) {
            context.$message.error(err.msg || err.message);
        }
    });
}
